<template>
  <div>
    <div class="botonera-audit">
      <b-button-group size="sm" id="audit-btn-cercar">
        <b-button size="sm" v-b-toggle.collapse-filtre  variant="outline-primary">
          <b-icon icon="filter" aria-hidden="true"></b-icon>
        </b-button>
        <b-button size="sm" variant="outline-primary" @click.prevent="listAuditAcces()">
          <b-icon icon="search" aria-hidden="true"></b-icon> {{$t('btn.cercar')}}
        </b-button>
      </b-button-group>
    </div>

    <b-collapse id="collapse-filtre" class="mt-2">
      <b-card class="filtre-audit">
        <b-row>
          <b-col lg="3" md="8" sm="10">
            <b-input-group size="sm" prepend="Nom usuari: ">
              <b-form-input id="filter-input" type="search" placeholder="Escriviu el nom d'un usuari" v-model="cercaNomUsuari" ref="formInputCerca" style="z-index:1;"> </b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="5" md="10" sm="12">
            <b-input-group  id="input-group-datepicker" size="sm" prepend="Rang de dates: ">
              <b-form-datepicker id="datepicker-inici" hide-header label-help="" placeholder="Data inici" size="sm" v-model="cercaDataHoraInici" class="mb-2"></b-form-datepicker>
              <b-form-datepicker id="datepicker-fi" hide-header label-help="" placeholder="Data fi" size="sm" v-model="cercaDataHoraFi" class="mb-2"></b-form-datepicker>
            </b-input-group>
          </b-col>
          <b-col lg="4" md="2" sm="10" class="filtre-btn-audit">
            <b-button size="sm" variant="outline-primary" @click.prevent="onResetFiltreCerca()">
              <b-icon icon="trash" aria-hidden="true"></b-icon> Eliminar filtre
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-collapse>

    <template>
      <div>
        <b-table id="audit-table" ref="usuarisTable" small :fields="campos" :items="files" responsive="sm" :current-page="currentPageStatic" :per-page="perPageStatic">
          <template v-slot:cell()="data">
            <div class="mb-2">
              <b-card no-body >
                <b-card-header class="header-audit">
                  <b-row>
                    <b-col lg="9" md="8" sm="6"><b>Auditoria d'accessos</b></b-col>
                  </b-row>
                </b-card-header>

                <div class="accordion" role="tablist">

                  <b-collapse visible :id="`${'collapse-usuaris-'+data.id}`" :accordion="`${'accordion-'+data.id}`" role="tabpanel">
                    <b-list-group flush>
                      <b-list-group-item class="titol-audit">
                        <b-row no-gutters >
                          <b-col md="3" sm="6">
                            <span class="label-titol-audit">{{$t('admin.audit.llistat.usuari')}}</span>
                          </b-col>
                          <b-col md="3" sm="6">
                            <span class="label-titol-audit">{{$t('admin.audit.llistat.data')}}</span>
                          </b-col>
                          <b-col md="3" sm="6">
                            <span class="label-titol-audit">{{$t('admin.audit.llistat.recurs')}}</span>
                          </b-col>
                          <b-col md="2" sm="6">
                            <span class="label-titol-audit">{{$t('admin.audit.llistat.peticio')}}</span>
                          </b-col>
                          <b-col md="1" sm="6">
                            <span class="label-titol-audit">{{$t('admin.audit.llistat.adreca')}}</span>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                      <template v-if="items.length<1">
                        <b-list-group-item style="padding-top: 2px;padding-bottom: 2px;">No hi ha registres.</b-list-group-item >
                      </template>
                      <template v-for="(item) in itemsForList">
                        <ItemAudit v-bind:key='item.idAudit+mountedTime' v-bind:initialValue="item" />
                      </template>
                    </b-list-group>
                  </b-collapse>

                </div>

              </b-card>

            </div>
          </template>
        </b-table>
      </div>
    </template>

    <b-pagination v-model="currentPage" pills align="center" :total-rows="rows" :per-page="perPage" aria-controls="audit-table"></b-pagination>

  </div>
</template>

<script>
import auditAccesService from "../../services/AuditAccesService";
import ItemAudit from "@/components/admin/ItemAudit";
export default {
  name: "admin-audit-acces",
  components: {
    ItemAudit
  },
  computed:{
    campos(){
      //Els fiquem a computed per les traduccions
      return [
        { key: 'e', label: '',thClass:'th-audit-table',tdClass:'td-audit-table' }
      ];
    },
    itemsForList() {
      return this.items.slice(
          (this.currentPage - 1) * this.perPage,
          this.currentPage * this.perPage,
      );
    }
  },
  data() {
    return {
      //id neecessari perquè la taula només tingui una única fila i pugui contenir a dins tot el llistat
      files: [
        { id: 1 },
      ],
      cercaNomUsuari: '',
      cercaDataHoraInici: null,
      cercaDataHoraFi: null,
      usuari: {},
      entitatUsuariActual: {},
      filtre:{},
      rows: 0,
      perPageStatic: 1,
      currentPageStatic: 1,
      perPage: 15,
      currentPage: 1,
      auditList: [],
      items: [],
      initialValue: {},
      rowSelected: {},
      mountedTime:null,
      accioUsuariModalId:null
    };
  },
  methods: {
    async listAuditAcces() {
      try{
        const response = await auditAccesService.listAuditAcces(this.filtre);
        console.log(response.data);
        // this.auditList =response.data;
        this.items = response.data;
        this.initItems();
      }catch(e){
        console.log(e);
      }
    },
    initItems(){
      console.log(this.items.length );
      if(this.items.length > 0){
        this.filtraAuditAcces();
      }

      console.log(this.items);
      this.rows = this.items.length;
      this.$root.$emit('bv::refresh::table', 'audit-table')
    },
    filtraAuditAcces(){
      this.items = this.items.filter(audit => audit.usuari.nomUsuari.includes(this.cercaNomUsuari));

      console.log(this.items[0].dataHora);
      console.log(this.obtenirNomesData(this.items[0].dataHora));

      if(this.cercaDataHoraInici != null){
        this.items = this.items.filter(element => {
          return this.cercaDataHoraInici <= this.obtenirNomesData(element.dataHora);
        });
      }

      if(this.cercaDataHoraFi != null){
        this.items = this.items.filter(element => {
          return this.cercaDataHoraFi >= this.obtenirNomesData(element.dataHora);
        });
      }

      console.log("this.cercaDataHoraInici");
      console.log(this.cercaDataHoraInici);
    },
    onResetFiltreCerca(){
      this.cercaDataHoraInici= null;
      this.cercaDataHoraFi=null;
      this.cercaNomUsuari = '';
      this.initItems();

    },
    obtenirNomesData(data){
      return data.substring(0,10);
    }
  },
  mounted() {
    console.log("MOUNTED");
    this.mountedTime = new Date().getTime();
  },
  created () {
    console.log("CREATED");
    this.listAuditAcces();
  }
};
</script>

<style>
.botonera-audit {
  text-align: right;
  margin-top: 10px;
  margin-bottom: 10px
}
.filtre-btn-audit {
  text-align: right;
}
#audit-btn-cercar{
  margin-right: 5px;
}
#audit-table{
  text-align: left;
  color: #858796;
  border: 0 solid #e3e6f0;
}
.th-audit-table{
  vertical-align: middle !important;
  padding: .45rem !important;
}
.td-audit-table{
  vertical-align: middle !important;
  padding: 0 !important;
}
.td-progress-bar{
  min-width: 80px;
}

.header-audit{
  padding: 0.2rem 1.25rem;
  background-color:rgba(0, 0, 0, 0.128);
}
.titol-audit{
  padding-top: 2px;
  padding-bottom: 2px;
  background-color:rgba(0, 0, 0, 0.068);
}
.label-titol-audit{
  font-weight: 500;
  font-size: 14px;
}
#input-group-datepicker .input-group-prepend{
  padding: 4px;
  margin-right: -4px;
  margin-top: -4px;
  margin-bottom: 4px;
}

</style>